import latest from './latest.json';

export interface Project {
    id: string;
    name: string;
    host: string;
    /** 공개 사이트만 링크가 있다. 비공개 작업은 이름만 보여준다. */
    url?: string;
}

export const profile = {
    nameKo: '정대교',
    greeting: '안녕하세요.',
    roles: ['디자이너', '디벨로퍼'],
    intro: {
        lead: '끊임없는 고민, 다양한 시도, 생각을 구현',
        highlight: '좋은 상호작용',
        rest: '을 만드는 데 관심 있습니다.',
    },
    taste: '브루탈리즘과 카세트 퓨처리즘을 좋아하고, 필름 카메라와 카세트 같은 오래된 아날로그를 좋아합니다.',
    links: [
        { label: 'GITHUB', url: 'https://github.com/Daekyo-Jeong' },
        { label: 'INSTAGRAM', url: 'https://www.instagram.com/da2kyo' },
        { label: 'CONTACT', url: 'mailto:dk@dkdk.me' },
    ],
};

export interface CareerItem {
    date: string;
    text: string;
}

export interface CareerGroup {
    title: string;
    items: CareerItem[];
}

// 2021년까지는 daekyojeong.com/about에서 옮겼다
export const career: CareerGroup[] = [
    {
        title: '경력',
        items: [
            { date: '2021.12 – 현재', text: '에이치나인 인터랙션 디자이너' },
        ],
    },
    {
        title: '학력',
        items: [
            { date: '2014.03 – 2020.02', text: '홍익대학교 디지털미디어디자인전공 졸업' },
        ],
    },
];

export interface ArchiveWork {
    id: string;
    title: string;
    period: string;
    fields: string;
    summary: string;
    cover: string;
    url?: string;
}

// 작업물 소개는 다음 작업. 지금은 daekyojeong.com/works에 있던 일곱 점만 옮겼다
export const archive: ArchiveWork[] = [
    {
        id: 'dk-w-rld',
        title: 'dk_w_rld',
        period: '2021',
        fields: 'Web development, UX/UI design',
        summary: '직접 디자인하고 개발한 포트폴리오 웹사이트.',
        cover: 'archive/dk-w-rld.jpg',
        url: 'http://www.daekyojeong.com',
    },
    {
        id: 'breathe',
        title: 'Breathe',
        period: '2019.03 – 2019.12',
        fields: 'Web development, UX/UI design',
        summary: '홍익대학교 디지털미디어디자인전공 졸업전시 브랜드와 웹사이트.',
        cover: 'archive/breathe.png',
        url: 'https://daekyo-jeong.github.io/Project/breathe-demo/',
    },
    {
        id: 'salt-factory',
        title: 'Salt Factory',
        period: '2018.11 – 2018.12',
        fields: 'Development, Interaction design',
        summary: '들고 다니며 연주하는 음악 장치. 물의 양에 따라 볼륨이 바뀐다.',
        cover: 'archive/salt-factory.png',
    },
    {
        id: 'moonecklace',
        title: 'Moonecklace',
        period: '2018.09 – 2018.10',
        fields: 'Development, Interaction design',
        summary: '짝이 되는 기기와 떨어져 있는 시간만큼 펜던트에 달이 차오른다.',
        cover: 'archive/moonecklace.png',
    },
    {
        id: 'food-a-cappella',
        title: 'Food A Cappella',
        period: '2018.05 – 2018.06',
        fields: 'Interaction design, Performance',
        summary: '립 모션으로 재료를 쥐어 냄비에 넣으면 재료마다 소리가 난다.',
        cover: 'archive/food-a-cappella.png',
    },
    {
        id: 'universe',
        title: 'Universe',
        period: '2018.03 – 2018.04',
        fields: 'Graphic design, Interaction design',
        summary: '학번의 숫자를 행성으로 바꿔 사람마다 다른 우주를 그린다.',
        cover: 'archive/universe.png',
    },
    {
        id: 'lima-duolympic',
        title: 'LIMA Duolympic',
        period: '2015.10 – 2015.12',
        fields: 'Graphic design, Branding',
        summary: '2024 리스본, 마드리드 듀올림픽을 가정한 브랜딩.',
        cover: 'archive/lima-duolympic.png',
    },
];

export const projects: Project[] = [
    { id: 'feed', name: '책장', host: 'feed.dkdk.me', url: 'https://feed.dkdk.me' },
    { id: 'lab', name: '실험실', host: 'lab.dkdk.me', url: 'https://lab.dkdk.me' },
    { id: 'mov', name: '극장', host: 'mov.dkdk.me', url: 'https://mov.dkdk.me' },
    { id: 'luck', name: '점집', host: 'luck.dkdk.me', url: 'https://luck.dkdk.me' },
    { id: 'toki', name: 'Toki', host: 'toki.dkdk.me', url: 'https://toki.dkdk.me' },
    { id: 'tape', name: '테이프', host: 'locked' },
    { id: 'arcade', name: '오락실', host: 'locked' },
];

export const feed = {
    url: 'https://feed.dkdk.me',
    count: latest.feed.count,
    items: latest.feed.items,
};

export const labLatest = latest.lab.items[0];

export const mov = {
    url: 'https://mov.dkdk.me',
    embed: 'https://mov.dkdk.me/embed',
};
